import React, { useEffect, useState } from "react";
import FireOnMenu from "./FireOnMenu";
import { useLocation, useParams } from "react-router-dom";
import DashboardMenu from "./DashboardMenu";
import { connectRealtimeDashboardWebSocket } from "../../websock/realtimeDashboardManager";
import {
  FirefightingActionEnum,
  getFirefightingActionEnumName,
} from "../../utils/common";
import useInterval from "../../utils/useInterval";
import { apiWrapper } from "../../apis/CommonApi";
import * as fireonApi from "../../apis/FireOnApi";
import { getDateTime } from "../../utils/date";
import monitorImg01 from "../../images/monitor_img01.png";
import PageHeader from "../PageHeader";

export default function FireAlarmMonitorComponent() {
  const { id } = useParams();
  const location = useLocation();
  const { buildingName } = location.state;
  const [ledStatus, setLedStatus] = useState(null);
  const [circuits, setCircuits] = useState([]);
  const [firefightingActionsLeft, setFirefightingActionsLeft] = useState([]);
  const [firefightingActionsRight, setFirefightingActionsRight] = useState([]);
  const [isOnFireRecovery, setIsOnFireRecovery] = useState(false);
  const [currentDateTime, setCurrentDateTime] = useState("");
  const [isDetectedFire, setIsDetectedFire] = useState(false);
  const [isVisibleLogo, setIsVisibleLogo] = useState(true);
  const [isToggledDetectedFire, setIsToggledDetectedFire] = useState(false);

  useEffect(() => {
    connectRealtimeDashboardWebSocket(id, (data) => {
      setLedStatus(data.ledStatus);

      //화재 감지 여부
      if (data.ledStatus[3] === 1
        || data.ledStatus[4] === 1
        || data.ledStatus[5] === 1
        || data.ledStatus[6] === 1
        || data.ledStatus[7] === 1) {
        setIsDetectedFire(true);
      } else {
        setIsDetectedFire(false);
      }
    });
    handleSetCurrentDateTime();
  }, []);

  useEffect(() => {
    if (ledStatus) {
      const data = ledStatus;
      setCircuits([
        { action: "회로1", isOn: data[3] === 1, isRed: false },
        { action: "회로2", isOn: data[4] === 1, isRed: false },
        { action: "회로3", isOn: data[5] === 1, isRed: false },
        { action: "회로4", isOn: data[6] === 1, isRed: false },
        { action: "회로5", isOn: data[7] === 1, isRed: false },
        { action: "발신기", isOn: data[20] === 1, isRed: true },
      ]);

      setFirefightingActionsLeft([
        {
          action: FirefightingActionEnum.ACCUMULATION,
          isOn: data[8] === 1,
          isRed: false,
        },
        {
          action: FirefightingActionEnum.GUIDING_LIGHT,
          isOn: data[9] === 1,
          isRed: false,
        },
        {
          action: FirefightingActionEnum.INDICATOR_LIGHT,
          isOn: data[10] === 1,
          isRed: false,
        },
        {
          action: FirefightingActionEnum.FIRE_ALARM,
          isOn: data[11] === 1,
          isRed: false,
        },
        {
          action: FirefightingActionEnum.OPERATION_TEST,
          isOn: data[12] === 1,
          isRed: false,
        },
      ]);

      setFirefightingActionsRight([
        {
          action: FirefightingActionEnum.CIRCUIT_BUZZER,
          isOn: data[13] === 0,
          isRed: false,
        },
        {
          action: FirefightingActionEnum.MAIN_ALARM,
          isOn: data[14] === 0,
          isRed: true,
        },
        {
          action: FirefightingActionEnum.LOCAL_ALARM,
          isOn: data[15] === 0,
          isRed: true,
        },
        {
          action: FirefightingActionEnum.AUTO_RECOVERY,
          isOn: data[16] === 1,
          isRed: false,
        },
        //화재복구 버튼은 예외적으로 동작시키기 위해 주석처리
        //{ action: FirefightingActionEnum.FIRE_RECOVERY, isOn: data[17] === 1, isRed: true },
      ]);
    }
  }, [ledStatus]);

  useInterval(() => {
    handleSetCurrentDateTime();
  }, 1000);

  useInterval(() => {
    setIsVisibleLogo(!isVisibleLogo);
  }, 5000, isDetectedFire === false);

  useInterval(() => {
    setIsToggledDetectedFire(!isToggledDetectedFire);
  }, 1000, isDetectedFire);

  const handleSetCurrentDateTime = () => {
    setCurrentDateTime(getDateTime(new Date()));
  };

  const handleControl = (action, isOn) => {
    if (action === FirefightingActionEnum.FIRE_RECOVERY) {
      //화재복구 버튼 클릭 시에는 1초 점등 후 소등
      setIsOnFireRecovery(true);
      setTimeout(() => {
        setIsOnFireRecovery(false);
      }, 1000);
    }

    apiWrapper(async () => {
      const { status, data } = await fireonApi.controlFireFightingObject(
        id,
        action,
        isOn
      );
      alert(`${data}`);
    });
  };

  return (
    <section id="darkMode" class="mbSection darkMode pb-per">
      <PageHeader isBlack={true} title={buildingName} isUseMenu={true} />
      {ledStatus && (
        <div class="container pb-137">
          <div class="controlPanel">
            <div class="panel-wrap top-panel">
              <div className={`item_panel ${ledStatus[0] === 1 ? "on" : ""}`}>
                <div class="status_cir"></div>
                <div class="item_title">
                  <p class="title">상용전원</p>
                </div>
              </div>
              <div className={`item_panel ${ledStatus[1] === 1 ? "on" : ""}`}>
                <div class="status_cir"></div>
                <div class="item_title">
                  <p class="title">예비전원</p>
                </div>
              </div>
              <div className={`item_panel ${ledStatus[2] === 1 ? "on" : ""}`}>
                <div class="status_cir red_cir"></div>
                <div class="item_title">
                  <p class="title">배터리이상</p>
                </div>
              </div>
              <div className={`item_panel ${ledStatus[18] === 1 ? "on" : ""}`}>
                <div class="status_cir"></div>
                <div class="item_title">
                  <p class="title">통신</p>
                </div>
              </div>
            </div>
            <div id="monitor" class="wrap_monitor">
              <div className={`monitor-view txt-w ${(() => {
                let viewType = "view02";

                //화재 감지
                if (isDetectedFire) {
                  if (isToggledDetectedFire) {
                    viewType = "view03";
                  } else {
                    viewType = "view04";
                  }
                }

                return viewType;
              })()}`}>
                <div className="info-wrap">
                  <p className="date">{currentDateTime}</p>
                  <p className="connection-status">
                    LTE
                    <i className="x-icon"></i>
                  </p>
                </div>

                {isDetectedFire ? (
                  //화재 감지 시 화면
                  <div className="mid-wrap">
                    <p class="view-title">
                      {(() => {
                        const messages = [];

                        // 화재구역 1
                        if (ledStatus[3] === 1) {
                          messages.push("1");
                        }
                        // 화재구역 2
                        if (ledStatus[4] === 1) {
                          messages.push("2");
                        }
                        // 화재구역 3
                        if (ledStatus[5] === 1) {
                          messages.push("3");
                        }
                        // 화재구역 4
                        if (ledStatus[6] === 1) {
                          messages.push("4");
                        }
                        // 화재구역 5
                        if (ledStatus[7] === 1) {
                          messages.push("5");
                        }

                        return "화재구역: " + (messages.length > 0 ? messages.join(", ") : "");
                      })()}
                    </p>
                    <p class="view-title">화재 감지!!!</p>
                  </div>
                ) :
                  //평상 시 화면
                  isVisibleLogo ? (
                    <div className="mid-wrap">
                      <img src={monitorImg01} alt="알엠테크솔루션" />
                    </div>
                  ) : (
                    <>
                      <div className="mid-wrap">
                        <p class="view-title">
                          <span>스마트 IoT 화재수신기</span>
                          <br />
                          (P형 수신기)
                        </p>
                      </div>
                      <div className="status-wrap">
                        <p className="title">동작 상태 : </p>
                        <p className="title">
                          {(() => {
                            const messages = [];

                            // 입력회로단락 상태 확인
                            // 입력회로단락 상태는 5개로 5비트 데이터
                            if (ledStatus[19] !== 0) {
                              const shortCircuits = [...Array(5)]
                                .map((_, index) => index + 1) // 1부터 5까지의 숫자 생성
                                .filter((bit) => (ledStatus[19] & (1 << (bit - 1))) !== 0); // 비트가 1인지 확인
                              messages.push(`입력회로단락(${shortCircuits.join(",")})`);
                            }

                            // 교류전원 이상 상태 확인
                            if (ledStatus[0] === 0) {
                              messages.push("교류전원 이상");
                            }

                            // 배터리 이상 상태 확인
                            if (ledStatus[2] === 1) {
                              messages.push("배터리 이상");
                            }

                            // 메시지가 없으면 "정상" 표시
                            return messages.length > 0 ? messages.join(", ") : "정상";
                          })()}
                        </p>
                      </div>
                    </>
                  )
                }
              </div>
            </div>

            {/* <!-- 화재입력 표시등 --> */}
            <p class="panel-title">화재입력 표시등</p>
            <div class="panel-wrap mid-panel">
              {circuits.length > 0 &&
                circuits.map((circuit, index) => (
                  <div className={`item_panel ${circuit.isOn ? "on" : ""}`}>
                    <div class="status_cir red_cir"></div>
                    <div class="item_title">
                      <p className={`title ${circuit.isRed ? "red" : ""}`}>
                        {circuit.action}
                      </p>
                    </div>
                  </div>
                ))}
            </div>

            {/* <!-- 수신기 동작 표시등/스위치 --> */}
            <p class="panel-title">수신기 동작 표시등 / 스위치</p>
            <div class="panel-duble-wrap">
              <div class="panel-wrap btm-panel">
                {firefightingActionsLeft.length > 0 &&
                  firefightingActionsLeft.map((item, index) => (
                    <div
                      className={`item_panel ${item.isRed ? "red" : ""}`}
                    >
                      <button
                        class="status_cir type2"
                        onClick={() => handleControl(item.action, !item.isOn)}
                      ></button>
                      <div class="item_title">
                        <p class={`title`}>
                          {getFirefightingActionEnumName(item.action)}
                        </p>
                      </div>
                      <div className={`status_cir ${item.isOn ? "on" : ""}`}></div>
                    </div>
                  ))}
              </div>
              <div class="panel-wrap btm-panel">
                {firefightingActionsRight.length > 0 &&
                  firefightingActionsRight.map((item, index) => (
                    <div
                      className={`item_panel ${item.isRed ? "red" : ""}`}
                    >
                      <button
                        class="status_cir type2"
                        onClick={() => handleControl(item.action, !item.isOn)}
                      ></button>
                      <div class="item_title">
                        <p class={`title`}>
                          {getFirefightingActionEnumName(item.action)}
                        </p>
                      </div>
                      <div className={`status_cir ${item.isOn ? "on" : ""}`}></div>
                    </div>
                  ))}
                <div
                  className={`item_panel red ${isOnFireRecovery ? "on" : ""}`}
                >
                  <button
                    class="status_cir type2 red_cir"
                    onClick={() =>
                      handleControl(FirefightingActionEnum.FIRE_RECOVERY, true)
                    }
                  ></button>
                  <div class="item_title">
                    <p class="title red">
                      {getFirefightingActionEnumName(
                        FirefightingActionEnum.FIRE_RECOVERY
                      )}
                    </p>
                  </div>
                  <div class="status_cir red_cir"></div>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}

      <div id="dashboardMenu" class="active_03">
        <DashboardMenu buildingName={buildingName} />
      </div>
      <FireOnMenu />
    </section>
  );
}
